var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-bottom-sheet',{ref:"tableSheet",attrs:{"background-clickable":false,"background-scrollable":false,"click-to-close":true,"is-full-screen":true,"maxHeight":'75%',"maxWidth":'95%',"overlay":true,"rounded":true,"swipe-able":true}},[_c('TableDetails',{attrs:{"tab":_vm.tab,"is-history":_vm.isHistory},on:{"click":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }